<template>
  <section class="testimonials-section section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">{{ $config.testimonials.title }}</h2>
      </div>
      <div class="testimonials-grid">
        <div class="testimonial-card" v-for="(review, index) in $config.testimonials.reviews" :key="index">
          <h3 class="testimonial-title">{{ review.title }}</h3>
          <p class="testimonial-text">"{{ review.text }}"</p>
          <div class="testimonial-author">
            <img :src="review.avatar" alt="用户头像" />
            <span>{{ review.author }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection'
}
</script>

<style scoped>
.testimonials-section {
  background-color: rgba(235, 242, 242, 1);
}
.section-header {
  text-align: center;
  margin-bottom: 50px;
}
.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #1A202C;
}
.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  align-items: stretch;
}
.testimonial-card {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.testimonial-title {
  font-size: 18px;
  font-weight: 600;
  color: rgba(14, 61, 69, 1);
  margin-bottom: 8px;
  margin-top: 0;
}
.testimonial-text {
  font-size: 16px;
  color: rgba(14, 61, 69, 1);
  margin-bottom: 12px;
  flex-grow: 1;
}
.testimonial-author {
  display: flex;
  align-items: center;
  margin-top: auto;
}
.testimonial-author img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 15px;
}
.testimonial-author span {
  font-size: 14px;
  color: rgba(14, 61, 69, 1);
}

@media (max-width: 768px) {
  .testimonials-grid {
    grid-template-columns: 1fr;
  }
}
</style>